import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { DashboardGroup } from './auth-groups';

export const authGuard: CanActivateFn = route => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated) {
    return router.createUrlTree(['/login']);
  }

  const groups = route.data?.['groups'] as DashboardGroup[] | undefined;
  if (!groups?.length || auth.hasAnyGroup(groups)) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};
